import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterOutlet } from "@angular/router";
import { SplashScreenComponent } from "./shared/components/splash-screen/splash-screen.component";
import { SplashScreenService } from "./shared/services/splash-screen.service";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [RouterOutlet, FlexLayoutModule, SplashScreenComponent, AsyncPipe],
    providers: [],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss"
})
export class AppComponent {
    title = "Nucont";
    showSplashScreen$;

    constructor(private splashScreenService: SplashScreenService) {
        this.showSplashScreen$ = this.splashScreenService.showSplashScreen$;
    }
}

console.log(`
╔══════════════════════════════════════════════════════════════╗
║                                                              ║
║        ██████╗  █████╗ ███████╗██╗  ██╗                      ║
║        ██╔══██╗██╔══██╗██╔════╝██║  ██║                      ║
║        ██║  ██║███████║███████╗███████║                      ║
║        ██║  ██║██╔══██║╚════██║██╔══██║                      ║
║        ██████╔╝██║  ██║███████║██║  ██║                      ║
║        ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝                      ║
║                                                              ║
║                      v1.9.2                                  ║
║                                                              ║
╚══════════════════════════════════════════════════════════════╝
`);
